import React from "react"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import TableActionBar from "../../layout/TableActionBar"
import { Paper, Table, TableBody, TableRow, TableRowColumn, CircularProgress } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { IScheduleDocument, IScheduleSearch, EDayOfWeek, EScheduleListType, IJobDocument, IClientDocument, IDate, IScheduleConstraint, EScheduleConstraintSeverity } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import ScheduleListTable from "../schedule_list/ScheduleListTable"
import SchedulesActionBar from "./SchedulesActionBar"
import moment from "moment"
import * as api from "../../../api"
import * as timeHelper from "../../../helpers/timeHelper"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import CopyScheduleDialog from "../copy_schedule/CopyScheduleDialog"
import ScheduleResourcePlanner from "./schedule-resource-planner/ScheduleResourcePlanner"
import AddScheduleDialog from "./add_schedule/AddScheduleDialog"
import PostSchedulePlannerConfirmDialog from "./PostScheduleConfirmDialog"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import { debounce } from "lodash"
import * as jobHelper from "../../../helpers/jobHelper"
import ScheduleConstraintsAlertDialog from "../constraints/ScheduleConstraintsAlertDialog"
import _ from "lodash"

interface IProps {
    readonly?: boolean
    type: EScheduleListType

    //job->Schedule
    job?: IJobDocument

    //client->Schedule
    client?: IClientDocument
}
interface IState {
    showAllChildHierarchyData: boolean
    schedules: IScheduleDocument[]
    selectedSchedules: IScheduleDocument[]
    searchText: string
    loading: boolean
    total: number
    offset: number
    limit: number
    constraintsAlertDialogContent: IScheduleConstraint[]
    constraintsAlertDialogHandleProceed: any

    // not used in PostedSchedule
    openAddScheduleDialog: boolean

    //not used in MasterSchedule    
    // it's Local time
    startDate: string
    endDate: string
    openCopyScheduleDialog: boolean

    //used in PostedSchedule 
    //used when includePlanShifts = false case too in JobSchedule and ClientSchedule
    showResourcePlanner: boolean

    //used in SchedulePlanner or MasterSchedule
    candidatePostSchedule: IScheduleDocument

    //used in JobSchedule
    addShiftDisabled: boolean

    //used in 
    includePlanShifts: boolean
}

export default class ScheduleList extends React.Component<IProps, IState> {
    private tabView //true is mean Job->Schedule && Client->Schedule
    private startDayOfWeek = EDayOfWeek.Monday
    constructor(props: IProps) {
        super(props)
        this.tabView = ![EScheduleListType.Master, EScheduleListType.Posted, EScheduleListType.Planner].includes(props.type)
        if (!this.tabView) {
            this.startDayOfWeek = payGroupAndTypeHelper.getInheritedPaygroupByGlobalHierarchy().PaySettings.PayPeriodStartDay
        }
        else if (props.job) {
            const payGroupId = payGroupAndTypeHelper.getPayGroupIdByUserPayrollData(
                {
                    Id: null,
                    PayrollHierarchyItemId: props.job.HierarchyId,
                    PayrollPayGroupId: null,
                    DefaultPunchHierarchyId: props.job.HierarchyId,
                    DefaultJobId: props.job.Id
                },
                props.job
            )
            const payGroup = payGroupAndTypeHelper.getPayGroupById(payGroupId)
            if (payGroup) {
                this.startDayOfWeek = payGroup.PaySettings.PayPeriodStartDay
            }
        }
        const referenceDate = localStorage.getItem("findd_posted_schedules_startDate") ?
            moment(localStorage.getItem("findd_posted_schedules_startDate")).add(10, "hours") :
            moment().format()
        const thisWeek = timeHelper.getWeekRange(this.startDayOfWeek, referenceDate)

        this.state = {
            showAllChildHierarchyData: true,
            schedules: [],
            selectedSchedules: [],
            searchText: "",
            loading: true,
            total: 0,
            offset: 0,
            limit: 50,
            startDate: thisWeek.startDate,
            endDate: thisWeek.endDate,
            openCopyScheduleDialog: false,

            showResourcePlanner: false,

            candidatePostSchedule: null,
            openAddScheduleDialog: false,

            addShiftDisabled: this.getAddShiftDisabled(thisWeek.startDate, thisWeek.endDate),

            includePlanShifts: true,
            constraintsAlertDialogContent: [],
            constraintsAlertDialogHandleProceed: null
        }
        autobind(this)
    }

    componentDidMount() {
        !this.tabView && HierarchySettingsStore.on("global_change", this.getSchedules)
        this.getSchedules()
    }

    componentWillUnmount() {
        !this.tabView && HierarchySettingsStore.removeListener("global_change", this.getSchedules)
    }

    async getSchedules() {
        const accountId = AccountStore.getCurrentAccount().Id
        const page = this.state.offset / this.state.limit
        const { limit, searchText, includePlanShifts, showAllChildHierarchyData } = this.state
        const levelIdFilter = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : ""
        const startDate = moment(this.state.startDate).utc(true).format()
        const endDate = moment(this.state.endDate).utc(true).format()
        const posted = this.props.type === EScheduleListType.Posted
        const response =
            this.props.type === EScheduleListType.ClientSchedule ?
                await api.getClientSchedules(this.props.client.Id, startDate, endDate, includePlanShifts, page, limit, searchText) :
                this.props.type === EScheduleListType.JobSchedule ?
                    await api.getJobSchedules(this.props.job.Id, startDate, endDate, includePlanShifts, page, limit, searchText) :
                    this.props.type === EScheduleListType.Master ?
                        await api.getMasterSchedules(accountId, page, limit, searchText, levelIdFilter, showAllChildHierarchyData) :
                        await api.getSchedules(accountId, startDate, endDate, posted, page, limit, searchText, levelIdFilter, showAllChildHierarchyData)

        const result = response.data as IScheduleSearch
        if (this.props.type === EScheduleListType.JobSchedule) {
            result.Documents = result.Documents.map(schedule => {
                const hiddenSchedules = []
                schedule.Schedules = schedule.Schedules.filter(pt => {
                    const jobSt = pt.ShiftTemplates.find(st => st.JobId === this.props.job.Id)
                    if (!jobSt) {
                        hiddenSchedules.push(pt)
                    }
                    return jobSt ? true : false
                })
                schedule.HiddenSchedules = hiddenSchedules
                return schedule
            })
        }

        if (this.props.type === EScheduleListType.ClientSchedule) {
            result.Documents = result.Documents.map(schedule => {
                const hiddenSchedules = []
                schedule.Schedules = schedule.Schedules.filter(pt => {
                    const clientSt = pt.ShiftTemplates.find(st => st.ClientId === this.props.client.Id)
                    if (!clientSt) {
                        hiddenSchedules.push(pt)
                    }
                    return clientSt ? true : false
                })
                schedule.HiddenSchedules = hiddenSchedules
                return schedule
            })
        }

        if (AccountStore.getJobsEnabled()) {
            result.Documents = result.Documents.map(schedule => {
                const hiddenSchedules = []
                schedule.Schedules = schedule.Schedules.filter(pt => {
                    const accessSt = pt.ShiftTemplates.find(st => jobHelper.getSupervisorAccessJobPermission(st.JobId))
                    if (!accessSt) {
                        hiddenSchedules.push(pt)
                    }
                    return accessSt ? true : false
                })
                schedule.HiddenSchedules = hiddenSchedules
                return schedule
            })
        }

        this.setState({
            loading: false,
            total: result.TotalDocumentCount,
            schedules: result.Documents,
            selectedSchedules: [],
        })
    }

    getAddShiftDisabled(startDate: IDate, endDate: IDate): boolean {
        if (this.props.job && this.props.job.HasStartEndDates) {
            let disabled = true
            const diffDays = moment(endDate).diff(startDate, "day")
            for (let i = 0; i <= diffDays; i++) {
                if (scheduleHelper.checkValidJobShiftDayByJobDate(this.props.job, moment(startDate).add(i, "day"))) {
                    disabled = false
                }
            }
            return disabled
        }
        else {
            return false
        }
    }

    handleCopySchedule(schedule: IScheduleDocument) {
        schedule.MasterSchedule = false
        api.copySchedule(schedule.StartDate, [schedule], true, true)
            .then(() =>
                AppStateStore.setProgressSnackbarContent(strings.Master_Schedule_posted_successfully)
            )
            .catch(err =>
                AppStateStore.setProgressSnackbarContent(err.response.data.message)
            )
    }

    handlePostSchedulePlanner(scheduleDocId: string, ignorePendingTimeoffWarningConflict: boolean = false) {
        api.postSchedulePlanner(scheduleDocId, ignorePendingTimeoffWarningConflict).then((res) => {
            const scheduleConstraints = res.data as IScheduleConstraint[]
            if (res.data.length > 0) {
                this.setState({
                    constraintsAlertDialogContent: res.data,
                    constraintsAlertDialogHandleProceed: scheduleConstraints.find(i => i.Severity === EScheduleConstraintSeverity.Error) ?
                        null :
                        () => this.handlePostSchedulePlanner(scheduleDocId, true)
                })
                AppStateStore.setProgressSnackbarContent(null)
            }
            else {
                AppStateStore.setProgressSnackbarContent(strings.Schedule_Planner_posted_successfully)
                this.getSchedules()
            }
        })
    }

    render() {
        const content = [
            <TableActionBar
                key="ScheduleCopySearchActionBar"
                rowSelectionCount={this.state.selectedSchedules.length}
                singleSelectedMessage={strings.Schedule_Selected}
                multipleSelectedMessage={strings.x_Schedules_Selected}
                title={this.props.type === EScheduleListType.Posted ?
                    strings.Posted_Schedules :
                    this.props.type === EScheduleListType.Planner ?
                        strings.Schedule_Planners :
                        this.props.type === EScheduleListType.Master ?
                            strings.Master_Schedules :
                            strings.Schedule
                }
                searchText={this.state.searchText}
                reloadTable={() => this.setState({ loading: true }, () => this.getSchedules())}
                onSearch={debounce((searchText) => this.setState({ loading: true, searchText }, () => this.getSchedules()), 1000)}
                onDeleteClick={!this.props.readonly &&
                    permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteSchedule) &&
                    (() => this.state.selectedSchedules.find(i => i.HiddenSchedules && i.HiddenSchedules.length > 0) ?
                        AppStateStore.setAlertDialogContent({
                            content: strings.Cannot_delete_in_here_Schedule_has_the_shift_which_is_not_shown_here
                        }) :
                        AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_delete_the_selected_schedule,
                            confirm: () => {
                                AppStateStore.setProgressSnackbarContent("loading")
                                api.deleteSchedule(this.state.selectedSchedules.map(item => item.Id)).then(() => {
                                    AppStateStore.setProgressSnackbarContent(strings.Schedule_removed_successfully)
                                    this.getSchedules()
                                })
                            }
                        })
                    )
                }
                onCopyClick={!this.props.readonly &&
                    permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddSchedule) &&
                    this.state.selectedSchedules.length === 1 &&
                    (() => this.state.selectedSchedules.find(i => i.HiddenSchedules && i.HiddenSchedules.length > 0) ?
                        AppStateStore.setAlertDialogContent({
                            content: strings.Cannot_copy_in_here_Schedule_has_the_shift_which_is_not_shown_here
                        }) :
                        this.setState({ openCopyScheduleDialog: true })
                    )
                }
            />,
            <SchedulesActionBar
                key="SchedulesActionBar"
                type={this.props.type}
                showAllChildHierarchyData={this.state.showAllChildHierarchyData}
                handleChangeShowAllChildHierarchyData={showAllChildHierarchyData => this.setState({ showAllChildHierarchyData, loading: true }, () => this.getSchedules())}

                //not in MasterSchedule    
                startDayOfWeek={this.startDayOfWeek}
                referenceDate={this.state.startDate}
                handleChangeWeek={(startDate, endDate) =>
                    this.setState({
                        startDate,
                        endDate,
                        addShiftDisabled: this.getAddShiftDisabled(startDate, endDate),
                        loading: true
                    }, () => {
                        localStorage.setItem("findd_posted_schedules_startDate", moment(startDate).format())
                        this.getSchedules()
                    })}

                //Posted Schedule
                showResourcePlanner={this.state.showResourcePlanner}
                handleChangeShowResourcePlanner={showResourcePlanner => this.setState({ showResourcePlanner })}

                //Job->Schedule && Client->Schedule
                includePlanShifts={this.state.includePlanShifts}
                handleChangeIncludePlanShifts={includePlanShifts =>
                    this.setState({
                        includePlanShifts,
                        showResourcePlanner: includePlanShifts ? false : this.state.showResourcePlanner,
                        loading: true
                    }, () => this.getSchedules())
                }
            />,
            <div key="content" style={{ padding: 20 }}>
                {this.state.loading ?
                    <div className="spinner"><CircularProgress /></div> :
                    !this.state.schedules.length ?
                        <Table>
                            <TableBody displayRowCheckbox={false}>
                                <TableRow>
                                    <TableRowColumn>
                                        <h2 style={{ textAlign: "center", marginTop: 25 }}>
                                            {strings.No_schedule_found}
                                        </h2>
                                    </TableRowColumn>
                                </TableRow>
                            </TableBody>
                        </Table> :
                        (this.props.type === EScheduleListType.Posted ||
                            (this.tabView && !this.state.includePlanShifts)
                        ) &&
                            this.state.showResourcePlanner ?
                            <ScheduleResourcePlanner
                                readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.DeleteSchedule) && !permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddSchedule)}
                                postedSchedules={this.state.schedules}
                                reload={this.getSchedules}
                            /> :
                            <ScheduleListTable
                                readonly={this.props.readonly}
                                type={this.props.type}
                                schedules={this.state.schedules}
                                selectedSchedules={this.state.selectedSchedules}
                                handleSelect={(selectedSchedules) => this.setState({ selectedSchedules })}
                                total={this.state.total}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[20, 50, 100]}
                                onPageClick={(offset) => this.setState({ loading: true, offset }, () => this.getSchedules())}
                                onLimitChange={(limit) => this.setState({ loading: true, offset: 0, limit }, () => this.getSchedules())}
                                handlePostSchedule={(candidatePostSchedule) => {
                                    candidatePostSchedule.HiddenSchedules && candidatePostSchedule.HiddenSchedules.length > 0 ?
                                        AppStateStore.setAlertDialogContent({
                                            content: strings.Cannot_post_in_here_Schedule_has_the_shift_which_is_not_shown_here
                                        }) :
                                        this.setState({ candidatePostSchedule })
                                }}
                                reload={this.getSchedules}
                                handleChangeWithoutApiCall={schedule => {
                                    const { schedules } = this.state
                                    const indexOf = schedules.findIndex(i => i.Id === schedule.Id)
                                    if (indexOf > -1) {
                                        schedules[indexOf] = schedule
                                        this.setState({ schedules })
                                    }
                                }}
                                job={this.props.job}
                                client={this.props.client}
                            />
                }
            </div>
        ]

        return (
            <div className={this.tabView ? null : "page-container"}>
                <div className={this.tabView ? null : "page-container-parent"}>
                    {!this.props.readonly && this.props.type !== EScheduleListType.Posted &&
                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.AddSchedule) &&
                        <FloatingActionButton
                            data-intercom-target={"menu-Schedules-SchedulePlanners-Btn-Add"}
                            secondary
                            className="fixed-add"
                            style={{ top: this.tabView ? -15 : 83, right: this.tabView ? 50 : 40, zIndex: 998 }}
                            onTouchTap={() => !this.state.addShiftDisabled && this.setState({ openAddScheduleDialog: true })}
                            disabled={this.state.addShiftDisabled}
                            title={this.state.addShiftDisabled ? strings.Current_selected_date_range_is_outside_of_the_Job_date_range : ""}
                        >
                            <ContentAdd />
                        </FloatingActionButton>
                    }
                    {this.tabView ?
                        <div style={{ paddingTop: 30 }}>
                            {content}
                        </div> :
                        <Paper zDepth={1} className="page-paper">
                            {content}
                        </Paper>
                    }
                    {this.state.openAddScheduleDialog &&
                        <AddScheduleDialog
                            type={this.props.type}
                            startDate={this.state.startDate}
                            handleClose={() => this.setState({ openAddScheduleDialog: false })}
                            handleAdd={schedule => {
                                AppStateStore.setProgressSnackbarContent("loading")
                                this.setState({ openAddScheduleDialog: false }, () =>
                                    api.addSchedule(schedule).then(() => {
                                        AppStateStore.setProgressSnackbarContent(strings.Schedule_added_successfully)
                                        this.getSchedules()
                                    })
                                )
                            }}
                            job={this.props.job}
                            client={this.props.client}
                        />
                    }
                    {this.state.candidatePostSchedule &&
                        <PostSchedulePlannerConfirmDialog
                            schedule={this.state.candidatePostSchedule}
                            handlePostSchedule={schedule => {
                                AppStateStore.setProgressSnackbarContent("loading")
                                this.setState({ candidatePostSchedule: null }, async () => {
                                    if (schedule.MasterSchedule) {
                                        let candidateSchedule = _.cloneDeep(schedule)
                                        candidateSchedule = scheduleHelper.initScheduleSchema(schedule.StartDate, _.cloneDeep(schedule)) as IScheduleDocument
                                        candidateSchedule.MasterSchedule = false
                                        const newScheduleValidate = await api.getValidationForNewSchedule(candidateSchedule)
                                        AppStateStore.setProgressSnackbarContent(null)
                                        const scheduleConstraints = newScheduleValidate.data as IScheduleConstraint[]
                                        scheduleConstraints.length ?
                                            this.setState({
                                                constraintsAlertDialogContent: scheduleConstraints,
                                                constraintsAlertDialogHandleProceed: scheduleConstraints.find(i => i.Severity === EScheduleConstraintSeverity.Error) ?
                                                    null :
                                                    () => this.handleCopySchedule(schedule)
                                            }) :
                                            this.handleCopySchedule(schedule)
                                    }
                                    else {
                                        this.handlePostSchedulePlanner(schedule.Id)
                                    }
                                })
                            }}
                            handleClose={() => this.setState({ candidatePostSchedule: null })}
                        />
                    }
                    {this.state.openCopyScheduleDialog &&
                        <CopyScheduleDialog
                            schedules={this.state.selectedSchedules}
                            handleClose={() => this.setState({ openCopyScheduleDialog: false })}
                            handleReloadPage={this.getSchedules}
                            job={this.props.job}
                            client={this.props.client}
                        />
                    }
                    {this.state.constraintsAlertDialogContent.length > 0 &&
                        <ScheduleConstraintsAlertDialog
                            constraints={this.state.constraintsAlertDialogContent}
                            handleClose={() => this.setState({ constraintsAlertDialogContent: [], constraintsAlertDialogHandleProceed: null })}
                            handleProceed={this.state.constraintsAlertDialogHandleProceed}
                        />
                    }
                </div>
            </div>
        )
    }
}